import { createActions, createReducer } from 'reduxsauce'

import AnexosAdiantamentosSuprimentosService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAnexosAdiantamentosSuprimentosInicio: [],
    buscaAnexosAdiantamentosSuprimentosSucesso: ['anexosAdiantamentosSuprimentos'],
    buscaAnexosAdiantamentosSuprimentosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAnexosAdiantamentosSuprimentos = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAnexosAdiantamentosSuprimentosInicio())
        let serv = new AnexosAdiantamentosSuprimentosService()
        return serv
            .consultarAnexosDetalhesAdvertenciaFornecedor(filtro)
            .then(response => dispatch(Creators.buscaAnexosAdiantamentosSuprimentosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAnexosAdiantamentosSuprimentosErro(error)))
    }
}

const buscaAnexosAdiantamentosSuprimentosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAnexosAdiantamentosSuprimentosErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaAnexosAdiantamentosSuprimentosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.anexosAdiantamentosSuprimentos, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ANEXOS_ADIANTAMENTOS_SUPRIMENTOS_INICIO]: buscaAnexosAdiantamentosSuprimentosInicio,
    [Types.BUSCA_ANEXOS_ADIANTAMENTOS_SUPRIMENTOS_ERRO]: buscaAnexosAdiantamentosSuprimentosErro,
    [Types.BUSCA_ANEXOS_ADIANTAMENTOS_SUPRIMENTOS_SUCESSO]: buscaAnexosAdiantamentosSuprimentosSucesso,
})
